import React, { ReactNode } from 'react';
import { Button, Grow, Paper, Popper } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';

export interface PopperButtonProps {
  buttonContent: (expanded: boolean) => ReactNode;
  children: ReactNode;

  top?: boolean;
}

const buttonSx: SxProps<Theme> = {
  '&:hover': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.04)',
  },
};

const buttonExpandedSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  boxShadow: 4,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  '&:hover': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'dark'
        ? theme.palette.grey[700]
        : theme.palette.grey[100],
  },
};

export const PopperButton = (props: PopperButtonProps) => {
  const { buttonContent, children, top } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      <Button
        sx={anchorEl != null ? buttonExpandedSx : buttonSx}
        onClick={handleClick}
        variant={'text'}
      >
        {buttonContent(anchorEl != null)}
      </Button>
      <Popper
        open={anchorEl != null}
        anchorEl={anchorEl}
        placement={top ? 'top-end' : 'bottom-end'}
        transition
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            timeout={350}
            style={{ transformOrigin: 'top right' }}
          >
            <Paper sx={{ borderTopRightRadius: 0, padding: 2 }} elevation={4}>
              {children}
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
